import { nanoid } from "nanoid";
export const data = {
  id: nanoid(),
  title: "content",
  subtitle: "I’m Front-end Developer, UI/UX and Poster Desginer",
  link: "Learn more about me",
  image: "./assets/Image/avatar-noBG.png",
};
